import { Flex } from 'antd';
import { SLA_PARTNER_KIND_COLORS } from '@/app/landing/sla/shared/utils/sla-status.utils';
import { SlaTypeDot } from '@/app/landing/sla/shared/components/SlaTypeDot';

type Props = {
  variant: 'landlord' | 'oem';
};

export function SlaPartnerKindDot({ variant }: Props) {
  return (
    <Flex align="center" justify="center">
      <SlaTypeDot color={SLA_PARTNER_KIND_COLORS[variant]} size={12} />
    </Flex>
  );
}
